import React, { useState } from 'react';
import PushLogo from './pushlogorect.svg';
import PushLogoLarge from './pushlogolarge.svg';
import { AxiosError } from 'axios';
import getAxios from './../lib/axios/axios';
import { Button } from "@uicomponents";
import styles from './Signup.module.scss';

function Signup() {
  const [customer_name, setCustomerName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [address_line_1, setAddressLine1] = useState<string>("");
  const [postal_code, setPostalCode] = useState<string>("");
  const [error, setError] = useState<string | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [cta, setCTA] = useState<string>("");
  const [ctaSubheader, setCTASubheader] = useState<string>("");

  const successCTA = "You're in!";

  const addUser = async () => {
    const axios = getAxios();
    setIsLoading(true);
    try {
      const response = await axios.post("/demo/users", {
        customer_name, 
        email,
        address_line_1,
        postal_code
      })
      setCTA(successCTA);
      setCTASubheader("Check your email for your access link")
      setIsLoading(false);
    }
  
    catch (error: any) {
      setIsLoading(false);

      if (error instanceof AxiosError && error.response)  {
        // 403 means access is restricted to the demo, ie we added them to the demo
        if (error.response.status === 403) {
          setCTA("Request received");
          setCTASubheader("We're rolling out our beta access and will send an invite via email soon.")
        } else {
          setError(error.response.data);
          if (error.response.status >= 500) {
            console.error(error);
          }
        }
      } else {
        setError(error.toString());
        console.error(error);
      }
    }
  }

  if (cta !== "") {
    var classNames = ["App"]
    if (cta === successCTA) {
      classNames.push(styles['success'])
    }
    return (
      <div className={classNames.join(' ')}>
        <div className="header">
          <img src={PushLogoLarge} alt='Logo' className={styles['cta-logo']} />
        </div>
        <div className="cta">
          <h1 className={styles['cta-header']}>{cta}</h1>
          <h4 className={styles['cta-subheader']}>{ctaSubheader}</h4>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="App">
        <div className="cta">
          <h2>An error occurred</h2>
          <p>Details: <code>{error}</code></p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="header">
        <img src={PushLogo} alt='Logo' />
        <h3 className={styles['header-text']}>Request Access</h3>
      </div>
      <div className="content">
        <h4 className={styles['content-copy']}>
            Signup to try our product demo!
        </h4>
        <h4 className={styles['content-copy']}>
            Look for an email from <b className={styles['email']}>hello@pushcash.com</b> after submitting your request
        </h4>
        <form className={styles['form']}>
          <input 
            type="text" 
            id="customer_name" 
            className={styles['input']}
            name="customer_name" 
            placeholder="Name"
            value={customer_name} 
            onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
              setCustomerName(e.target.value);
            }}>
          </input>
          <input 
            type="email" 
            id="email" 
            className={styles['input']}
            name="email" 
            placeholder="Email"
            value={email} 
            onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
              setEmail(e.target.value);
            }}>
          </input>
          <input 
            type="text" 
            id="address" 
            className={styles['input']}
            name="address" 
            placeholder="Street Address"
            value={address_line_1} 
            onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
              setAddressLine1(e.target.value);
            }}>
          </input>
          <input 
            type="text" 
            id="postal-code" 
            className={styles['input']}
            name="postal-code" 
            placeholder="Zip"
            value={postal_code} 
            onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
              setPostalCode(e.target.value);
            }}>
          </input>
        </form>
      </div>
      <div className="footer">
        <Button
          type="cta"
          disabled={isLoading || (!customer_name || !email || !address_line_1 || !postal_code)}
          text={isLoading ? "Loading..." : "Get Started"}
          onClick={addUser} />
      </div>
    </div>
  );
}

export default Signup;
